import { Box, Heading, FlexProps, Flex, VStack } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { AvailableIcon } from 'src/components/atoms/Icon';
import { ReactNode } from 'react';

export interface CardProps extends FlexProps {
  headerText: string;
  iconName: AvailableIcon;
  children?: ReactNode;
}

export const Card: React.FC<CardProps> = ({
  headerText,
  iconName,
  children,
  ...flexProps
}) => (
  <Box
    as="section"
    borderRadius="2xl"
    p={9}
    textAlign="left"
    bg="background.lightGrey"
    _hover={{ shadow: 'md' }}
    h="100%"
    display="flex"
    flexDirection="column"
    {...flexProps}>
    {/* Icon + heading */}
    <Flex mb={6} align="flex-start">
      <Icon iconName={iconName} w={12} h={12} mr={4} flexShrink={0} />
      <Heading
        as="h3"
        size="md"
        fontFamily="marketingPage"
        fontWeight="bold"
        textTransform={'uppercase'}
        lineHeight="1.2">
        {headerText}
      </Heading>
    </Flex>

    <VStack flex="1" align="stretch" spacing={0}>
      {children}
    </VStack>
  </Box>
);
